<app-modal *ngIf="vo$ | async; let vo" (triggerClose)="close()">
	<ng-container modal-body>
		<app-exposition-access-config
			[accessConfig]="vo.access"
		></app-exposition-access-config>
	</ng-container>

	<div modal-footer class="app-expositions-access-modal__footer">
		<div
			*ngIf="vo.currentError"
			class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.currentError.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.currentError.type === 'critic' ? DcIcons.Cancel : DcIcons.Warning"></mat-icon>
			<span>{{ vo.currentError.message }}</span>
		</div>
		<button
			*ngIf="vo.canEdit"
			[color]="'primary'"
			id="{{ cmpId }}-save-btn"
			class="app-expositions-access-modal__footer__btn"
			mat-raised-button
			[disabled]="vo.currentError!==undefined"
			(click)="save()">
			<mat-icon [svgIcon]="DcIcons.Save"></mat-icon>
			<span *ngIf="vo.isNewConfig" i18n="@@general.action.save">save</span>
			<span *ngIf="!vo.isNewConfig" i18n="@@general.action.update">update</span>
		</button>
	</div>
</app-modal>
